const apiBaseUrl = "https://api.internal.casiostore.com.cn/web";
const webBaseUrl = "https://h5.internal.casiostore.com.cn/";
//测试站
// const apiBaseUrl = 'http://api.internal-purchase.test.xcxd.ltd/web'
// const webBaseUrl = 'http://internal-purchase.test.xcxd.ltd/'
// 本地
// const apiBaseUrl = "http://127.0.0.1:8013/web";
// const webBaseUrl = "http://127.0.0.1:8080/";

import { newWorld } from "@/helpers/index";

export default {
  title: newWorld() ? "卡西欧商城-新世界专场" : "企业员工内购",

  siteLogo: newWorld()
    ? require("../assets/site-logo1.png")
    : require("../assets/site-logo.png"),
  loginBackground: require("../assets/login/background.png"),
  qrcodes: [],
  copyright: "卡西欧官方商城",
  icp: "京ICP备 10009123号-10",
  customerService: {
    tel: "400-700-6655",
    time: "(周一至周日 9:00-21:00)",
  },

  api: {
    baseURL: apiBaseUrl,
  },

  client: {
    web: {
      baseUrl: webBaseUrl,
    },
    admin: {
      baseUrl: "http://localhost:8081",
    },
  },

  // pc/h5 设备跳转：pc 端访问 h5 站点时自动跳回 pc 站点首页
  domain: {
    pc: "https://internal.casiostore.com.cn",
    h5: "https://h5.internal.casiostore.com.cn/",
  },
};
